<template>
  <section id="landing" class="home">
    <!-- <div class="section-navigation">
      <ul>
        <li data-menuanchor="home" class="active"><a v-on:click="moveSection(0)">
            <div class="extended-text">
              <div class="text-container"><span>Intro</span></div>&mdash;
            </div>
            <div class="indicator"></div>
          </a></li>
        <li data-menuanchor="about"><a v-on:click="moveSection(1)">
            <div class="extended-text">
              <div class="text-container"><span>Mission</span></div>&mdash;
            </div>
            <div class="indicator"></div>
          </a></li>
        <li data-menuanchor="universe"><a v-on:click="moveSection(2)">
            <div class="extended-text">
              <div class="text-container"><span>Universe</span></div>&mdash;
            </div>
            <div class="indicator"></div>
          </a></li>
        <li data-menuanchor="prepack"><a v-on:click="moveSection(3)">
            <div class="extended-text">
              <div class="text-container"><span>Prepack Planner</span></div>&mdash;
            </div>
            <div class="indicator"></div>
          </a></li>
          <li data-menuanchor="clarity"><a v-on:click="moveSection(4)">
            <div class="extended-text">
              <div class="text-container"><span>Clarity</span></div>&mdash;
            </div>
            <div class="indicator"></div>
          </a></li>
          <li data-menuanchor="surface"><a v-on:click="moveSection(5)">
            <div class="extended-text">
              <div class="text-container"><span>Surface</span></div>&mdash;
            </div>
            <div class="indicator"></div>
          </a></li>
          <li data-menuanchor="higher"><a v-on:click="moveSection(6)">
            <div class="extended-text">
              <div class="text-container"><span>Higher</span></div>&mdash;
            </div>
            <div class="indicator"></div>
          </a></li>
          <li data-menuanchor="winning"><a v-on:click="moveSection(7)">
            <div class="extended-text">
              <div class="text-container"><span>Winning</span></div>&mdash;
            </div>
            <div class="indicator"></div>
          </a></li>
      </ul>
    </div> -->

    <vimeo-desktop class="vimeo reel video-background video-desktop"></vimeo-desktop>
    <vimeo-mobile class="vimeo reel video-background video-mobile"></vimeo-mobile>

    <full-page ref="fullpage" class="home-slider-container" :class="{ active: borderactive }" :options="options">
      <div class="section" id="sectionfirst">
        <div class="slide project-preview-container" id="slide01" data-project="01">
          <figcaption class="page-header-description topbottom">HOME</figcaption>
        </div>
      </div>

      <div class="mission-section section" id="sectionsecond">
        <div class="slide project-preview-container" id="slide02" data-project="02">
          <h2 class="flow-head">Connecting You <br />to New Business.</h2>

          <div class="flow-text">
            <p>You have something to say and it’s time to be heard.</p>
            <p>
              When you bring Branton on board, you’re betting on yourself, your team, and your brand. We get that. That’s why we’re fiercely committed to driving your business growth with relentless dedication.
            </p>
            <p>
              Connecting you with your customers. Telling your story. Adding value to your brand.
            </p>
          </div>

          <b-img class="flowb" fluid :src="require(`../assets/images/flowb.jpg`)" alt="Capabilities"></b-img>
          <div id="topheader">
            <!-- <vue-p5 @sketch="sketch"></vue-p5> -->
          </div>
        </div>
      </div>

      <div class="section" id="section2">
        <div class="slide project-preview-container" id="slide0" data-project="0">
          <div class="preview-text-container">
            <div class="preview-container">
              <h2>
                <div class="text-row"><span>Control Your Universe.</span></div>
                <div class="text-row"><span class="changeme">Any time, anywhere. Heating and cooling systems for high-rise condos.</span></div>
              </h2>
              <router-link to="/work/universe" class="animated-home-button">
                <div class="button-container">
                  <div class="button-content">
                    <div class="arrow-container">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve">
                        <g>
                          <g>
                            <path d="M293.4,245.9L109.3,430c-5.1,5.1-7.9,11.8-7.9,19c0,7.2,2.8,14,7.9,19l16.1,16.1c5.1,5.1,11.8,7.9,19,7.9s14-2.8,19-7.9L382.7,265c5.1-5.1,7.9-11.9,7.8-19.1c0-7.2-2.8-14-7.8-19.1L163.7,7.9c-5.1-5.1-11.8-7.9-19-7.9c-7.2,0-14,2.8-19,7.9L109.5,24C99,34.5,99,51.6,109.5,62L293.4,245.9z" />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <video id="featuredvideo4" class="featuredvideo" data-project="headline4" preload="auto" data-autoplay muted playsinline>
            <!-- <source src="@/assets/videos/unilux/Main-Page-Unilux.webm" type="video/webm" />
            <source src="@/assets/videos/unilux/Main-Page-Unilux.mp4" type="video/mp4" />
            <source src="@/assets/videos/unilux/Main-Page-Unilux.ogv" type="video/ogg" /> -->

            <!-- <source src="@/assets/videos/unilux/Main-Page-Unilux2.webm" type="video/webm" /> -->
            <source src="@/assets/videos/unilux/Main-Page-Unilux2.mp4" type="video/mp4" />
            <!-- <source src="@/assets/videos/unilux/Main-Page-Unilux2.ogv" type="video/ogg" /> -->
          </video>
        </div>
      </div>

      <div class="section" id="section3">
        <div class="slide project-preview-container" id="slide1" data-project="1">
          <div class="preview-text-container">
            <div class="preview-container">
              <h2>
                <div class="text-row"><span>A Fast Way to Find your Flavour.</span></div>
                <!-- <div class="text-row"><span>Find your Flavour.</span></div> -->
                <div class="text-row"><span class="changeme">Thousands of displays ready to order.</span></div>
              </h2>

              <router-link to="/work/prepack-planner" class="animated-home-button">
                <div class="button-container">
                  <div class="button-content">
                    <div class="arrow-container">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve">
                        <g>
                          <g>
                            <path d="M293.4,245.9L109.3,430c-5.1,5.1-7.9,11.8-7.9,19c0,7.2,2.8,14,7.9,19l16.1,16.1c5.1,5.1,11.8,7.9,19,7.9s14-2.8,19-7.9L382.7,265c5.1-5.1,7.9-11.9,7.8-19.1c0-7.2-2.8-14-7.8-19.1L163.7,7.9c-5.1-5.1-11.8-7.9-19-7.9c-7.2,0-14,2.8-19,7.9L109.5,24C99,34.5,99,51.6,109.5,62L293.4,245.9z" />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <video id="featuredvideo5" class="featuredvideo" poster="@/assets/videos/mccormick/mccormick-fallback.jpg" data-project="headline5" preload="auto" data-autoplay muted playsinline>
            <!-- <source src="@/assets/videos/mccormick/Main-Page-McCormick.webm" type="video/webm" /> -->
            <source src="@/assets/videos/mccormick/Main-Page-McCormick.mp4" type="video/mp4" />
            <!-- <source src="@/assets/videos/mccormick/Main-Page-McCormick.ogv" type="video/ogg" /> -->
          </video>
        </div>
      </div>

      <div class="section" id="section4">
        <div class="slide project-preview-container" id="slide2" data-project="2">
          <div class="preview-text-container">
            <div class="preview-container">
              <h2>
                <div class="text-row"><span>A Campaign that takes you Places.</span></div>
                <!-- <div class="text-row"><span>Find your Flavour.</span></div> -->
                <div class="text-row"><span class="changeme">Smiles that go on for miles.</span></div>
              </h2>

              <router-link to="/work/clarity" class="animated-home-button">
                <div class="button-container">
                  <div class="button-content">
                    <div class="arrow-container">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve">
                        <g>
                          <g>
                            <path d="M293.4,245.9L109.3,430c-5.1,5.1-7.9,11.8-7.9,19c0,7.2,2.8,14,7.9,19l16.1,16.1c5.1,5.1,11.8,7.9,19,7.9s14-2.8,19-7.9L382.7,265c5.1-5.1,7.9-11.9,7.8-19.1c0-7.2-2.8-14-7.8-19.1L163.7,7.9c-5.1-5.1-11.8-7.9-19-7.9c-7.2,0-14,2.8-19,7.9L109.5,24C99,34.5,99,51.6,109.5,62L293.4,245.9z" />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <video id="featuredvideo9" class="featuredvideo" poster="@/assets/videos/Main-Page-Clarity_Still.jpg" data-project="headline9" preload="auto" data-autoplay muted playsinline>
            <!-- <source src="@/assets/videos/mccormick/Main-Page-McCormick.webm" type="video/webm" /> -->
            <source src="@/assets/videos/Main-Page-Clarity.mp4" type="video/mp4" />
          </video>
        </div>
      </div>

      <div class="section" id="section5">
        <div class="slide project-preview-container" id="slide3" data-project="3">
          <div class="preview-text-container">
            <div class="preview-container">
              <h2>
                <div class="text-row"><span>A Food Safety Campaign that sees Beyond the Surface.</span></div>
                <!-- <div class="text-row"><span>Find your Flavour.</span></div> -->
                <div class="text-row"><span class="changeme">Accurate bacteria detection with speed.</span></div>
              </h2>

              <router-link to="/work/surface" class="animated-home-button">
                <div class="button-container">
                  <div class="button-content">
                    <div class="arrow-container">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve">
                        <g>
                          <g>
                            <path d="M293.4,245.9L109.3,430c-5.1,5.1-7.9,11.8-7.9,19c0,7.2,2.8,14,7.9,19l16.1,16.1c5.1,5.1,11.8,7.9,19,7.9s14-2.8,19-7.9L382.7,265c5.1-5.1,7.9-11.9,7.8-19.1c0-7.2-2.8-14-7.8-19.1L163.7,7.9c-5.1-5.1-11.8-7.9-19-7.9c-7.2,0-14,2.8-19,7.9L109.5,24C99,34.5,99,51.6,109.5,62L293.4,245.9z" />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <video id="featuredvideo6" class="featuredvideo" poster="@/assets/videos/Main-Page-FoodSafety-Still.jpg" data-project="headline6" preload="auto" data-autoplay muted playsinline>
            <!-- <source src="@/assets/videos/mccormick/Main-Page-McCormick.webm" type="video/webm" /> -->
            <source src="@/assets/videos/Main-Page-FoodSafety.mp4" type="video/mp4" />
          </video>
        </div>
      </div>

      <div class="section" id="section6">
        <div class="slide project-preview-container" id="slide4" data-project="4">
          <div class="preview-text-container">
            <div class="preview-container">
              <h2>
                <div class="text-row"><span>A Trade In Program with Higher Returns.</span></div>
                <!-- <div class="text-row"><span>Find your Flavour.</span></div> -->
                <div class="text-row"><span class="changeme">Helping to bring bottom lines to new heights.</span></div>
              </h2>

              <router-link to="/work/higher" class="animated-home-button">
                <div class="button-container">
                  <div class="button-content">
                    <div class="arrow-container">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve">
                        <g>
                          <g>
                            <path d="M293.4,245.9L109.3,430c-5.1,5.1-7.9,11.8-7.9,19c0,7.2,2.8,14,7.9,19l16.1,16.1c5.1,5.1,11.8,7.9,19,7.9s14-2.8,19-7.9L382.7,265c5.1-5.1,7.9-11.9,7.8-19.1c0-7.2-2.8-14-7.8-19.1L163.7,7.9c-5.1-5.1-11.8-7.9-19-7.9c-7.2,0-14,2.8-19,7.9L109.5,24C99,34.5,99,51.6,109.5,62L293.4,245.9z" />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <video id="featuredvideo7" class="featuredvideo" poster="@/assets/videos/Main-Page-Trade-Still.jpg" data-project="headline7" preload="auto" data-autoplay muted playsinline>
            <!-- <source src="@/assets/videos/mccormick/Main-Page-McCormick.webm" type="video/webm" /> -->
            <source src="@/assets/videos/Main-Page-Trade.mp4" type="video/mp4" />
          </video>
        </div>
      </div>

      <div class="section" id="section7">
        <div class="slide project-preview-container" id="slide5" data-project="5">
          <div class="preview-text-container">
            <div class="preview-container">
              <h2>
                <div class="text-row"><span>Winning.</span></div>
                <!-- <div class="text-row"><span>Find your Flavour.</span></div> -->
                <div class="text-row"><span class="changeme">Connecting electrical professionals to 3M.</span></div>
              </h2>

              <router-link to="/work/winning" class="animated-home-button">
                <div class="button-container">
                  <div class="button-content">
                    <div class="arrow-container">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve">
                        <g>
                          <g>
                            <path d="M293.4,245.9L109.3,430c-5.1,5.1-7.9,11.8-7.9,19c0,7.2,2.8,14,7.9,19l16.1,16.1c5.1,5.1,11.8,7.9,19,7.9s14-2.8,19-7.9L382.7,265c5.1-5.1,7.9-11.9,7.8-19.1c0-7.2-2.8-14-7.8-19.1L163.7,7.9c-5.1-5.1-11.8-7.9-19-7.9c-7.2,0-14,2.8-19,7.9L109.5,24C99,34.5,99,51.6,109.5,62L293.4,245.9z" />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <video id="featuredvideo8" class="featuredvideo" poster="@/assets/videos/Main-Page-UTS-Still.jpg" data-project="headline8" preload="auto" data-autoplay muted playsinline>
            <!-- <source src="@/assets/videos/mccormick/Main-Page-McCormick.webm" type="video/webm" /> -->
            <source src="@/assets/videos/Main-Page-UTS.mp4" type="video/mp4" />
          </video>
        </div>
      </div>

      <!-- <div class="section" id="section4">

        <b-row class="culture">

          <b-col col cols="12" lg="5">
            <b-row class="inside left">
              <b-col col cols="12"></b-col>
              <b-col col cols="5" md="6"></b-col>
              <b-col col cols="7" md="6"></b-col>
            </b-row>
          </b-col>

          <b-col col cols="12" lg="7" class="inside right">
            <b-row>



              <b-col col cols="4"></b-col>
              <b-col col cols="12" md="4" offset-md="-4">
                <b-row class="moreinside">
                  <b-col col cols="6" md="12">


                  </b-col>
                  <b-col col cols="6" md="12"></b-col>
                </b-row>
              </b-col>
              <b-col col cols="6" md="4"></b-col>


              <b-col col cols="6" md="4"></b-col>
              <b-col col cols="12" md="8"></b-col>
            </b-row>
          </b-col>



        </b-row>

      </div> -->
    </full-page>
  </section>
</template>

<script>
// import VueP5 from "vue-p5";
// eslint-disable-next-line
import VimeoDesktop from "./supports/vimeodesktop.vue";
import VimeoMobile from "./supports/vimeomobile.vue";

export default {
  metaInfo: {
    titleTemplate: "Welcome to Branton — A Creative Design Agency",
    meta: [
      {
        name: "Home",
        content: "Welcome to Branton, a creative agency. You have something to say and our mission is simple: Make sure you are heard. Connect with us and bring value to your business. ",
      },
    ],
  },
  // eslint-disable-next-line
  components: { VimeoDesktop, VimeoMobile },

  //  "vue-p5": VueP5
  data() {
    return {
      options: {
        anchors: ["home", "about", "universe", "prepack", "clarity", "surface", "higher", "winning"],
        menu: ".section-navigation ul",
        licenseKey: "7E4E7EAB-997043B6-8A86CC24-ABCA8700",
        sectionsColor: ["transparent", "white", "black", "black", "black", "grey", "black", "grey", "black"],
        scrollBar: true,
        fitToSection: false,
        scrollingSpeed: 800,
        fitToSectionDelay: 1000,
        touchSensitivity: 15,
        resetSliders: true,
        showActiveTooltip: true,
        navigation: false,
        lockAnchors: true,
        setAutoScrolling: false,
        slidesNavigation: false,
        controlArrows: false,
        afterLoad: this.afterLoad,
      },
      indexForNormalScroll: 0,
      slideTimeout: 10000,
      borderactive: false,
      waitLoad: false,
      slideAnimation: false,
      slideTimer: "",
      slidePush: "",
      leavetime: "",
      headlinetimer: "",
    };
  },
  mounted() {
    // We listen to the resize event
    window.addEventListener("resize", () => {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
  },
  created() {
    this.$gtag.pageview({
      page_path: "/",
    });
    window.addEventListener("scroll", this.scrollHandler);
  },

  destroyed() {
    window.removeEventListener("scroll", this.scrollHandler);
  },
  methods: {
    switchSlide(slide) {
      // eslint-disable-next-line
      fullpage_api.moveTo(7, slide);
      return;
    },
    // eslint-disable-next-line
    afterLoad(origin, destination, direction) {
      var self = this;
      self.waitLoad = false;
      self.borderactive = false;
      self.clearTimers();
      if (destination.index === self.indexForNormalScroll) {
        // eslint-disable-next-line
        fullpage_api.setAutoScrolling(false);
      }

      //         if (destination.index === 1) {
      //         // eslint-disable-next-line
      //         this.fullpage_api.setAutoScrolling(false);
      //         this.fullpage_api.scrollOverflow(false);
      // } else{
      //   this.fullpage_api.setAutoScrolling(true);
      // }

      // if (origin.index == 2) {
      //   var resetvideo = document.querySelectorAll('.project-preview-container');
      //   // eslint-disable-next-line
      //   Array.prototype.forEach.call(resetvideo, function (elements, index) {
      //     elements.querySelector('.featuredvideo').currentTime = 0;
      //   });
      // }

      let sliderNavButtons = document.querySelectorAll("#section6 .fp-slidesNav.fp-bottom ul li a");
      // eslint-disable-next-line
      Array.prototype.forEach.call(sliderNavButtons, function(el, index) {
        el.classList.remove("active");
      });
      // if (destination.index == 2) {
      //   this.clearTimers();
      //   // eslint-disable-next-line
      //   fullpage_api.moveTo(destination.index + 1, 0);
      // }

      let prevText = origin.item.children[0].children[0].children[0];
      prevText.classList.remove("section-animation-in");
      let currText = destination.item.children[0].children[0].children[0];
      currText.classList.add("section-animation-in");
    },
    // eslint-disable-next-line
    onSlideLeave(section, origin, destination, direction) {
      let self = this;
      var vid = document.getElementById("featuredvideo" + origin.item.dataset.project);
      vid.currentTime = 0;
      self.clearTimers();
    },

    clearTimers() {
      let self = this;
      clearTimeout(self.headlinetimer);
      clearTimeout(self.slidePush);
      clearTimeout(self.slideTimer);
      clearTimeout(self.leavetime);
    },
    scrollHandler() {
      var self = this;
      var normalSection = document.querySelectorAll(".section")[self.indexForNormalScroll];
      var offset = normalSection.offsetTop;
      let result = Math.ceil(self.getScrollTop());
      // console.log(result, offset);
      // eslint-disable-next-line
      if (result < offset && !fullpage_api.getFullpageData().options.autoScrolling) {
        // eslint-disable-next-line
        fullpage_api.setAutoScrolling(true);
      }
    },
    getScrollTop: function() {
      var doc = document.documentElement;
      return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    },
    moveSection(id) {
      // eslint-disable-next-line
      fullpage_api.moveTo(id + 1);
    },
  },
  watch: {},
};
</script>

<style lang="scss">
@import "@/assets/css/landing.scss";

#featuredvideo4,
#featuredvideo5,
#featuredvideo9,
#featuredvideo6,
#featuredvideo7,
#featuredvideo8 {
  background-size: cover;
  background-position: center;
}

#featuredvideo4 {
  background-image: url("../assets/videos/unilux/universe-fallback.png");
}
#featuredvideo5 {
  background-image: url("../assets/videos/mccormick/mccormick-fallback.jpg");
}
#featuredvideo9 {
  background-image: url("../assets/videos/Main-Page-Clarity_Still.jpg");
}
#featuredvideo6 {
  background-image: url("../assets/videos/Main-Page-FoodSafety-Still.jpg");
}
#featuredvideo7 {
  background-image: url("../assets/videos/Main-Page-Trade-Still.jpg");
}
#featuredvideo8 {
  background-image: url("../assets/videos/Main-Page-UTS-Still.jpg");
}

.featuredvideo {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.mission-section {
  // background-image: url("../assets/images/flowb.jpg");
  background-size: cover;
  background-color: white;

  h2 {
    text-align: left;
    max-width: 750px;
    padding: 30px;
    font-size: 1.2rem;
    font-weight: 300;
    margin: auto;
    color: white;

    @include media-breakpoint-up(md) {
      font-size: 1.6rem;
    }

    span {
      font-weight: 700;
      color: $b-orange;
    }
  }
}
.fp-tableCell {
  display: flex;
}

.video-background {
  position: relative;
  overflow: hidden;
  width: 100%; /* Changed from 100vw to 100% */
  height: 100%; /* Changed from 100vh to 100% */
}

.video-background video {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  object-fit: cover;
}

@media (min-aspect-ratio: 16/9) {
  .video-desktop video {
    height: 56.25vw;
  }
}
@media (max-aspect-ratio: 16/9) {
  .video-desktop video {
    width: 177.78vh;
  }
}

@media (min-aspect-ratio: 9/16) {
  .video-mobile video {
    width: 100vw;
    height: 177.78vw;
  }
}
@media (max-aspect-ratio: 9/16) {
  .video-mobile video {
    height: 100vh;
    width: 56.25vh;
  }
}

// .reel.video-front {
//     width: 100%;
//     height: 100%;
//     z-index: 100;
// }
// .reel.video-front iframe {
//     width: 100%;
//     height: 100%;
//     // padding: 20px;
// }

.video-desktop {
  display: none;
}
@include media-breakpoint-up(lg) {
  .video-mobile {
    display: none;
  }
  .video-desktop {
    display: block;
  }
}

.vimeo {
  z-index: 0;
  position: fixed;
}
div#sectionfirst {
  background-color: none !important;
}

img.flowb.img-fluid {
  width: 100%;
  padding-top: 60%;
  @include media-breakpoint-up(md) {
    padding-top: 20px;
  }
}

div#sectionsecond .fp-tableCell,
div#sectionsecond .fp-slide,
div#sectionsecond {
  height: auto !important;
}

h2.flow-head {
  position: absolute;
  color: #4a4f54;
  font-weight: 600;
  left: 20%;
  top: 3%;
  display: block;
  max-width: 70%;
  font-size: 6vw;

  @include media-breakpoint-up(md) {
    left: 24%;
    top: 7%;
    display: block;
    max-width: 60%;
    font-size: 6vw;
  }
}

.flow-text {
  position: absolute;
  left: 28%;
  top: 17%;
  font-size: 3.1vw;
  line-height: 4.3vw;
  max-width: 59%;
  display: block;

  @include media-breakpoint-up(md) {
    left: 29%;
    top: 46%;
    font-size: 1.3vw;
    line-height: 2.7vw;
    max-width: 39%;
  }
}
</style>
